function Slugify(text, delimiter = "_", prefix = "tbr") {
  if (typeof text !== "string") {
    text = "" + text;
  }

  const customText = text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, delimiter) // replace non-alphanumeric with delimiter
    .replace(new RegExp(`${delimiter}+`, "g"), delimiter) // remove multiple delimiters
    .replace(new RegExp(`^${delimiter}|${delimiter}$`, "g"), ""); // trim delimiters at ends
  return prefix + delimiter + customText;
}

export default Slugify;
